import { Component, Inject, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FADE_IN } from '../../../util/animations/animation';
import { HttpService } from '../../../services/http/http.service';
import { ToastrService } from 'ngx-toastr';
import { CommunicationService } from '../../../services/communication/communication.service';
/**
 * CareAlly can create or edit the labels by picking the available colors and add text. 
 *  
 * Add the labels  to the  tasks so that it will be uniquely identified.
 */
@Component({
  selector: 'app-label',
  templateUrl: './label.component.html',
  styleUrls: ['./label.component.scss'],
  animations: [FADE_IN]
})
export class LabelComponent {
  searchText: null;
  popupType = 'LIST';
  mode = '';
  selectedLabel:any = {};
  selectedLabelForEdit:any = {};
  labels = [];
  isShowLoader = false;

  /**
   * List of default color
   */
  colors = [
    {labelColor: '#F44336', selected: false},
    {labelColor: '#4CAF50', selected: false},
    {labelColor: '#FDD835', selected: false},
    {labelColor: '#9C27B0', selected: false},
    {labelColor: '#2196F3', selected: false},
    {labelColor: '#FFA000', selected: false},
    {labelColor: '#64FFDA', selected: false},
    {labelColor: '#607D8B', selected: false},
    {labelColor: '#CDDC39', selected: false},
    {labelColor: '#0097A7', selected: false}
  ]

  constructor(
    public dialogRef: MatDialogRef<LabelComponent>,
    @Inject(MAT_DIALOG_DATA) public popupData,
    private httpService: HttpService,
    private toastr: ToastrService,
    private communicationService: CommunicationService) {
      this.communicationService.getLabels.subscribe(labels=>{
        this.labels = this.setDefaultSeletedLabel(labels);
      })
    }

  /**
   * This function is used to set the selected label
   * @param labels 
   */
  setDefaultSeletedLabel(labels){
    labels.map(x=> {
      x.selected = this.popupData.task.labelObjects.findIndex(y=> y.id === x.id) !== -1
    })
    return labels;
  }

  onClosePopup(): void {
    this.resetEditData();
    this.dialogRef.close();
  }

/**
 * This function gets called on click of edit button
 * @param item 
 */
  onEdit(item){
    this.popupType = 'ADD_EDIT';
    this.mode = 'edit';
    this.selectedLabel = item;
    this.selectedLabelForEdit = {...item};
    this.colors.map(x=> { x.selected = x.labelColor === item.labelColor})
  }

  /**
   * This function is used to add or remove the label from list
   * @param item 
   */
  onAddRemoveLabel(item){
    item.selected = !item.selected;
    this.isShowLoader = true;
    const payload = {
      taskId: this.popupData.task.id,
      labelId: item.id
    }
    const url = item.selected? 'task/label' : 'task/label/remove';
    this.httpService.post(url, payload)
      .subscribe((response: any) => {
        this.isShowLoader = false;
      }, error =>{
        this.isShowLoader = false;
        this.toastr.warning(error, 'Queue', {
          progressBar: true, timeOut: 3000
        });
    })
  }

  /**
   * This function gets called when user clicks on label or color
   * @param item 
   */
  onSelectLabelColor(item){
    this.colors.map(x=> {
      if(x.labelColor === item.labelColor){
        x.selected = true;
        this.selectedLabel.labelColor = item.labelColor;
      }else
        x.selected = false;
    })
  }

  goBack(){
    this.popupType = 'LIST';
    // Reset color on back for edit operation
    this.resetEditData();
  }

  /**
   * This function is used to reset the data 
   */
  resetEditData(){
    if(this.selectedLabelForEdit.id){
      const index = this.labels.findIndex(x=> x.id === this.selectedLabelForEdit.id);
      if(index !== -1){
        this.labels[index].labelText = this.selectedLabelForEdit.labelText
        this.labels[index].labelColor = this.selectedLabelForEdit.labelColor
      }
    }
  }

  goBackFromDelete(){
    this.popupType = 'LIST';
  }

  /**
   * This function gets called when user clicks on Add button
  */
  onCreateBtnClick(){
    this.popupType = 'ADD_EDIT';
    this.mode = 'create';
    this.colors.map(x=> { x.selected = false })
    this.selectedLabel = {labelText: null, labelColor: null}
  }

  /**
   * This function gets called when user clicks on delete button
  */
  onDeleteBtnClick(){
      this.isShowLoader = true;
      const payload = {
        id: this.selectedLabel.id
      }
      this.httpService.post(`label/archive`, payload)
        .subscribe((response: any) => {
          this.isShowLoader = false;
          this.popupType = 'LIST';
        }, error =>{
          this.isShowLoader = false;
          this.toastr.warning(error, 'Queue', {
            progressBar: true, timeOut: 3000
          });
      })
  }

  /**
   * This function is used to add the new label by calling the API
   */
  onCreate(){
    this.isShowLoader = true;
    const payload = {
      queueBoard: this.popupData.queueBoardId,
      ...this.selectedLabel
    }
    this.httpService.post(`label`, payload)
      .subscribe((response: any) => {
        this.isShowLoader = false;
        this.popupType = 'LIST';
      }, error =>{
        this.isShowLoader = false;
        this.toastr.warning(error, 'Queue', {
          progressBar: true, timeOut: 3000
        });
    })
  }

  /**
   * This function is used to update the particular label by clicking on update button
   */
  onUpdate(){
      this.isShowLoader = true;
      delete this.selectedLabel.selected;
      const payload = {
        queueBoard: this.popupData.queueBoardId,
        labelText: this.selectedLabel.labelText, 
        labelColor: this.selectedLabel.labelColor
      }
      this.httpService.post(`label/${this.selectedLabel.id}`, payload)
        .subscribe((response: any) => {
          this.isShowLoader = false;
          this.popupType = 'LIST';
          this.selectedLabelForEdit = {};
        }, error =>{
          this.isShowLoader = false;
          this.toastr.warning(error, 'Queue', {
            progressBar: true, timeOut: 3000
          });
      })
  }

  onDelete(item){
    this.popupType = 'DELETE';
    this.selectedLabel = item;
  }

}